// @flow
export const filterId: 'studentStatus' = 'studentStatus';
